// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { MDBTableHead } from 'mdbreact';
import Sel from './Sel';

const Headers = ({
  columns,
  handlerSort,
  enableActionsCol,
  actionsColLabel = 'Actions',
  sortBy,
}) => (
  <thead >
    <tr>
      {
        columns.map(item => (
          <Sel
            key={item.value}
            item={item}
            handlerSort={handlerSort}
            sortBy={sortBy}
          />
        ))
      }
      {
        enableActionsCol
          ? (
            <th className="actions-col" aria-label={actionsColLabel || 'Row actions'}>
              {actionsColLabel}
            </th>
          )
          : <></>
      }
    </tr>
  </thead>
);

export default Headers;
